<template>
<div>
            <!-- {{$request.saatligoster(lastupdate) }} -->

           <van-pull-refresh v-model="isLoading" @refresh="onLoad">
            <div v-for="(item,index) in list" :key="index" >
              <!-- <router-link :to="`/grup/${item.cihazid}`"> status="Detay"-->
              <van-panel :title="item.cihazgrup" :desc="item.cihazaltgrup"  ></van-panel>
              <!-- </router-link> -->
            </div>
           </van-pull-refresh>

         <div style="height:70px"></div>
         <van-tabbar v-model="active">
          <van-tabbar-item name="Home" to="/" icon="wap-home-o">Home</van-tabbar-item>
          <van-tabbar-item name="Servis" to="/servis" icon="todo-list-o">Servis</van-tabbar-item>
          <van-tabbar-item name="Sepet" to="/sepet" icon="cluster-o">Ekibim</van-tabbar-item>
          <van-tabbar-item name="Depom" to="/depo" icon="apps-o">Depom</van-tabbar-item>
          <van-tabbar-item name="Cihaz" to="/gruplama" icon="fire-o">Cihaz</van-tabbar-item>
          <van-tabbar-item name="Hesabım" to="/hesap" icon="user-o">Hesap</van-tabbar-item>
         </van-tabbar>
<van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
</div>
</template>

<script>
import { Popup } from 'vant';
import { decode} from 'js-base64';

export default {
  data() {
    return {
      list: [],
      isLoading: false,
      active:'altgrup',
      depolar: [],
      showPicker: false,
      ayar:this.$request.ayar(),
      value1:'',
      popshow:false,
      show:false,
      depom:decode(this.$request.ayar().genel.d),
      kisa:decode(this.$request.ayar().genel.s),
      lastupdate : this.$request.ayar().songucelleme
    };
  },
  computed:{
    // filteredList() {
    //   return this.list.filter(post => {
    //     return post.sto_isim.toLowerCase().includes(this.value1.toLowerCase())
    //   })
    // }    
  },  
  created(){
    this.show = true
    this.onLoad();
  },
  methods: {

        onLoad() {
          this.$request.post("servis/api", {q:'cihaz_list',where:{}}).then(res => {
this.list=res.data 
 this.$store.dispatch("source",res.data).then(ok=>{

          this.show = false
          })

          }) 

        },

       
  }
};
</script>


// WEBPACK FOOTER //
// src/components/cihaz/altgrup.vue